import { createFileRoute, Link } from '@tanstack/react-router';
import { LinkLogo } from '@/components/nav/link-logo';
import { TrackingOptions } from '@/components/tracking-options';
import { ProfileFirstPromo } from '@/components/profiles/profile-first-promo';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/_auth/_basic-layout/start-tracking')({
  component: StartTracking,
});

function StartTracking() {
  return (
    <section className="py-12 sm:py-16 lg:py-20">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto">
          <div className="flex flex-col items-center">
            <LinkLogo />
            <h1 className="text-foreground mt-12 text-3xl font-bold">
              It&apos;s Time to Send Data
            </h1>
            <p className="text-muted-foreground mt-4 mb-10 font-medium">
              Use one of following integrations
            </p>
          </div>

          <TrackingOptions />

          <ProfileFirstPromo className="mt-10" />

          <div className="mt-10 flex justify-center">
            <Link to="/">
              <Button type="submit">View Collected Events</Button>
            </Link>
          </div>

          <div className="mt-6 text-center">
            <p className="text-foreground font-medium">
              Looking for Documentation?{' '}
              <a
                className="font-bold hover:underline"
                href="https://www.logspot.io/docs"
                rel="noreferrer"
                target="_blank"
                title=""
              >
                {' '}
                Read the Logspot Docs{' '}
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
